import { getJson } from "../../core/http";

export function fetchBillingCatalog() {
  return getJson("/api/v1/billing/catalog");
}
